import { createUseStyles } from 'react-jss'

export default createUseStyles({
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '25px 0',
    maxWidth: '350px',
    position: 'relative',
    width: '100%'
  },
  countdownCircleContent: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  },
  countdownText: {
    display: 'flex',
    fontFamily: 'B612MonoRegular',
    fontSize: '44px !important',
    justifyContent: 'center'
  },
  icon: {
    '& path': {
      fill: 'var(--icon__primary__stroke__color)',
      stroke: 'var(--icon__primary__stroke__color)'
    },
    marginTop: '15px'
  },
  outlinedButtonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  primaryOutlinedButton: {
    marginTop: '20px'
  },
  responsive: {
    alignItems: 'center',
    backgroundColor: 'var(--primary__page__background)',
    display: 'flex',
    flexDirection: 'column',
    height: '100% !important',
    justifyContent: 'flex-start !important',
    padding: '40px 20px !important',
    position: 'relative',
    width: '100% !important',
    overflow: 'none !important'
  },
  timerButtonTitle: {
    fontSize: '18px',
    pointerEvents: 'none'
  }
})

